import {useVariables} from '@dash-ui/react'
import {useWindowHeight} from '@react-hook/window-size'

export const useVh = () => {
  const vh = useWindowHeight()
  useVariables({vh: typeof window !== 'undefined' ? vh + 'px' : '100vh'}, [vh])
}
